<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<a
  [routerLink]="link"
  [queryParams]="params"
  class="btn btn-info btn-ico"
  [ngbTooltip]="'SALE_BUTTON.SALE' | translate"
  container="body"
  [target]="targetBlank ? '_blank' : '_self'"
>
  <i class="fal fa-hand-holding-usd"></i>
</a>
